import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import Offcanvas from "react-bootstrap/Offcanvas";

import Card from "react-bootstrap/Card";
import ModalSave from "../../../common/ModalSave";
import Validation from "../../../common/FormValidation";
import { CancelButton, SaveButton } from "../../../common/Button";
import { useForm, Controller } from "react-hook-form";
import {
  Container,
  Row,
  Col,
  Button,
  Form,
  InputGroup,
  Modal,
} from "react-bootstrap";
import classNames from "classnames";
library.add(fas);

const AddOffCanvance = (props) => {
  const { postData } = useContext(Context);
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    watch,
    getValues,
    setValue,
  } = useForm();

  const imageFile = watch("image");

  const onSubmit = async (data) => {
    try {
      const sendData = new FormData();
      sendData.append("name", data?.name);
      sendData.append("training_video", data?.training_video[0]);
      sendData.append("cover_image", data?.cover_image[0]);
      const response = await postData(`/masters/training-video`, sendData);

      if (response?.success) {
        await setShowModal({ code: response.code, message: response.message });
      } else {
        await setShowModal({
          code: response?.code,
          message: response?.message,
        });
      }
      setTimeout(() => {
        setShowModal(0);
        props.handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  const [videoFile, setVideoFile] = useState(null);

  console.log(videoFile, "videoFile");

  const handleVideoChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setVideoFile(e.target.files);
    }
  };

  return (
    <>
      <Offcanvas
        show={props.show}
        style={{ width: "80%" }}
        placement={"end"}
        onHide={props.handleClose}
      >
        <Offcanvas.Header closeButton>
          {/* <Offcanvas.Title>Add State</Offcanvas.Title> */}
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Card className="shadow-lg p-3 mb-5 bg-white rounded">
            <Card.Body>
              <Card.Title>Add Training Video</Card.Title>
              <hr />
              <Container>
                <Row>
                  <Col md={12}>
                    <Container>
                      <Row className="">
                        <Col xxl={12} xl={12} md={10}>
                          <Form onSubmit={handleSubmit(onSubmit)} role="form">
                            <Row className="justify-content-center">
                              <Col md={6}>
                                <div className="main-form-section mt-3">
                                  <Form.Group>
                                    <Form.Label>Name</Form.Label>
                                    <InputGroup>
                                      <Form.Control
                                        type="text"
                                        name="name"
                                        placeholder="Name"
                                        className={classNames("", {
                                          "is-invalid": errors?.name,
                                        })}
                                        {...register("name", {
                                          required: "Name is required",
                                        })}
                                      />
                                    </InputGroup>
                                    {errors.name && (
                                      <span className="text-danger">
                                        {errors.name.message}
                                      </span>
                                    )}
                                  </Form.Group>
                                </div>

                                <div className="main-form-section mt-3">
                                  <Row className="justify-content-start">
                                    {/* Label for the video input */}
                                    <Form.Label
                                      htmlFor="training_video"
                                      className="text-left"
                                    >
                                      Training Video
                                    </Form.Label>

                                    {/* File Input Group */}
                                    <Form.Group>
                                      <Form.Control
                                        className={classNames("", {
                                          "is-invalid": errors?.training_video,
                                        })}
                                        type="file"
                                        {...register("training_video", {
                                          onChange: handleVideoChange,
                                          required: "Video is required",
                                          validate: {
                                            fileSize: (value) =>
                                              (value &&
                                                value[0]?.size <=
                                                  50 * 1024 * 1024) || // 10 MB in bytes
                                              "File size must be less than 50 MB",
                                          },
                                        })}
                                        accept=".mp4, .mov, .avi"
                                      />
                                    </Form.Group>

                                    {errors.training_video && (
                                      <span className="text-danger">
                                        {errors.training_video.message}
                                      </span>
                                    )}
                                  </Row>
                                </div>
                              </Col>

                              <Col className="main-form-section mt-3">
                                <div className="main-form-section mt-3">
                                  <Row className="justify-content-center">
                                    <Form.Label
                                      column
                                      sm={3}
                                      className="text-center"
                                    >
                                      Video Preview
                                    </Form.Label>
                                    {videoFile && (
                                      <div className="video-preview-container">
                                        <video
                                          src={URL.createObjectURL(
                                            videoFile[0]
                                          )}
                                          controls
                                          className="video-preview"
                                          style={{
                                            width: "150px",
                                            height: "150px",
                                          }}
                                          onLoadedData={() =>
                                            URL.revokeObjectURL(
                                              URL.createObjectURL(videoFile[0])
                                            )
                                          }
                                        />
                                      </div>
                                    )}
                                  </Row>
                                </div>
                              </Col>

                              <div className="main-form-section mt-3">
                                <Row className="justify-content-start">
                                  <Form.Label className="text-left">
                                    Cover Image
                                  </Form.Label>

                                  <Form.Group>
                                    <Form.Control
                                      className={classNames("", {
                                        "is-invalid": errors?.cover_image,
                                      })}
                                      type="file"
                                      {...register("cover_image", {
                                        required: "Cover Image is required",
                                      })}
                                      accept=".jpg, .jpeg, .png"
                                    />
                                  </Form.Group>
                                  {errors.cover_image && (
                                    <span className="text-danger">
                                      {errors.cover_image.message}
                                    </span>
                                  )}
                                </Row>
                              </div>

                              <Col className="main-form-section mt-3">
                                <div className="main-form-section mt-3">
                                  <Row className="justify-content-center">
                                    <Form.Label
                                      column
                                      sm={3}
                                      className="text-center"
                                    >
                                      Cover Image Preview
                                    </Form.Label>
                                    {imageFile && imageFile?.length > 0 && (
                                      <div className="image-preview-container">
                                        <img
                                          // src={URL.createObjectURL(getValues("image")[0])}
                                          src={URL?.createObjectURL(
                                            imageFile[0]
                                          )}
                                          alt="Preview"
                                          className="image-preview"
                                          style={{
                                            width: "100px",
                                            height: "100px",
                                          }}
                                        />
                                      </div>
                                    )}
                                  </Row>
                                </div>
                              </Col>

                              <Row className="mt-5 pb-3">
                                <div className="d-flex justify-content-center">
                                  <Link>
                                    <CancelButton
                                      name={"cancel"}
                                      handleClose={props.handleClose}
                                    />
                                  </Link>

                                  <SaveButton
                                    name={"save"}
                                    handleSubmit={handleSubmit(onSubmit)}
                                  />
                                </div>
                              </Row>
                            </Row>
                          </Form>
                        </Col>
                      </Row>
                    </Container>
                  </Col>
                </Row>
              </Container>
            </Card.Body>
          </Card>
        </Offcanvas.Body>
      </Offcanvas>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default AddOffCanvance;
